import React from 'react'
import PropTypes from 'prop-types'
import { SearchResult } from 'types'
import exact from 'prop-types-exact'
import { pure } from 'recompose'
import OutsideClickHandler from 'react-outside-click-handler'
import { formatDisplayFromAddressSearchResult } from 'utils'
import classnames from 'classnames'

const propTypes = {
  closePanel: PropTypes.func.isRequired,
  hideLocationName: PropTypes.bool,
  isPanelOpen: PropTypes.bool.isRequired,
  searchResults: PropTypes.arrayOf(SearchResult),
  updateFormValues: PropTypes.func.isRequired,
}

function SearchResultsPanel({
  closePanel,
  hideLocationName = false,
  isPanelOpen,
  searchResults,
  updateFormValues,
}) {
  return (
    <OutsideClickHandler disabled={!isPanelOpen} onOutsideClick={closePanel}>
      <div
        className={classnames('autocomplete-wrapper', {
          'is-open': isPanelOpen,
        })}
      >
        <ul className="autocomplete">
          {searchResults &&
            searchResults.map((result, index) => {
              const resultDisplay = hideLocationName
                ? result.formatted_address
                : formatDisplayFromAddressSearchResult(result)

              return (
                <li key={resultDisplay + index}>
                  <button
                    type="button"
                    // Resolves issue where selecting a search result would 
                    // trigger a form submission and renders temporarily an 
                    // inline form error.
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => {
                      updateFormValues(result)
                      closePanel()
                    }}
                  >
                    {resultDisplay}
                  </button>
                </li>
              )
            })}
        </ul>
      </div>
    </OutsideClickHandler>
  )
}

SearchResultsPanel.propTypes = exact(propTypes)

export default pure(SearchResultsPanel)
